/**
 * `useMediaQuery` — wrapper reactivo de `window.matchMedia`.
 * Devuelve `false` en SSR / sin window (seguro para jsdom).
 */
import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(query);
    const update = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', update);
    return () => mql.removeEventListener('change', update);
  }, [query]);

  return matches;
}

/** Usuario prefiere movimiento reducido (system setting). */
export const useReducedMotion = () => useMediaQuery('(prefers-reduced-motion: reduce)');

/** Dispositivo touch (sin hover real). */
export const useCoarsePointer = () => useMediaQuery('(pointer: coarse)');
